import failedImage from "@/assets/verify-failed.png";
import { Button } from "@/components/ui/button/button";
import Spinner from "@/components/ui/spinner";
import { useToast } from "@/components/ui/use-toast";
import { AuthContext } from "@/context/auth-context";
import { useResendVerificationEmail } from "@/features/email-verification/useResendVerificationEmail";
import { useNavigate } from "@tanstack/react-router";
import { useContext } from "react";

const VERIFY_EMAIL_CALLBACK = `${window.location.origin}/verify-email`;

const EmailVerificationFailed = () => {
	const resendMutation = useResendVerificationEmail();
	const { toast } = useToast();
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const user = authContext?.user;

	const handleResend = () => {
		if (!user) {
			navigate({ to: "/sign-mail" });
			return;
		}
		resendMutation.mutate(
			{
				guest_id: user.id,
				email_verification_callback: VERIFY_EMAIL_CALLBACK,
			},
			{
				onSuccess: () => {
					toast({
						title: "Verification Email Sent",
						description:
							"Please check your inbox and follow the link to verify your email.",
					});
				},
				onError: (_) => {
					toast({
						title: "Verification Failed",
						description: "Failed to send verification email. Please try again.",
						variant: "destructive",
					});
				},
			},
		);
	};

	const isLoading = resendMutation.status === "pending";

	return (
		<div className="h-screen flex flex-col items-center justify-center transition-opacity duration-300 gap-3">
			<div className="flex flex-col items-center mb-4 space-y-3">
				<img src={failedImage} alt="failed" />

				<div className="flex flex-col items-center w-full">
					<h2 className="text-2xl font-bold text-textDark">
						Verification Failed
					</h2>
					<p className="text-sm text-textDark w-[65%] text-center mt-2">
						We couldn't verify your email address. The link may be expired or
						invalid.
					</p>
				</div>
			</div>
			<Button
				className="w-[300px]"
				variant={"default"}
				onClick={handleResend}
				disabled={isLoading}
			>
				{isLoading ? (
					<div className="flex items-center justify-center space-x-2">
						<Spinner />
					</div>
				) : user ? (
					"Resend Verification Email"
				) : (
					"Sign in to resend verification email"
				)}
			</Button>
		</div>
	);
};

export default EmailVerificationFailed;
